"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetNftTrackersResponseAllOfToJSON = exports.GetNftTrackersResponseAllOfFromJSONTyped = exports.GetNftTrackersResponseAllOfFromJSON = void 0;
var _1 = require("./");
function GetNftTrackersResponseAllOfFromJSON(json) {
    return GetNftTrackersResponseAllOfFromJSONTyped(json, false);
}
exports.GetNftTrackersResponseAllOfFromJSON = GetNftTrackersResponseAllOfFromJSON;
function GetNftTrackersResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'nftTrackers': (json['nftTrackers'].map(_1.NftTrackerFromJSON)),
    };
}
exports.GetNftTrackersResponseAllOfFromJSONTyped = GetNftTrackersResponseAllOfFromJSONTyped;
function GetNftTrackersResponseAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'nftTrackers': (value.nftTrackers.map(_1.NftTrackerToJSON)),
    };
}
exports.GetNftTrackersResponseAllOfToJSON = GetNftTrackersResponseAllOfToJSON;
